var _style, _defs, _defs2, _defs3, _defs4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDropzoneIllustration = function SvgDropzoneIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dropzone_illustration_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 116.9 110.4",
    style: {
      enableBackground: "new 0 0 116.9 110.4"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".dropzone_illustration_svg__st9{fill:#5d5d5d}.dropzone_illustration_svg__st10{font-family:'AvenirNextCondensed-Medium'}.dropzone_illustration_svg__st11{font-size:14px}")), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dropzone_illustration_svg__SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 5,
    y1: 47,
    x2: 116,
    y2: 47
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00a8d4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007aa9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8 5h105c1.7 0 3 1.3 3 3v78c0 1.7-1.3 3-3 3H8c-1.7 0-3-1.3-3-3V8c0-1.7 1.3-3 3-3z",
    style: {
      fill: "url(#dropzone_illustration_svg__SVGID_1_)"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "dropzone_illustration_svg__SVGID_2_",
    d: "M4 1h105c1.7 0 3 1.3 3 3v78c0 1.7-1.3 3-3 3H4c-1.7 0-3-1.3-3-3V4c0-1.7 1.3-3 3-3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "dropzone_illustration_svg__SVGID_3_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dropzone_illustration_svg__SVGID_2_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#dropzone_illustration_svg__SVGID_3_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 1h105c1.7 0 3 1.3 3 3v78c0 1.7-1.3 3-3 3H4c-1.7 0-3-1.3-3-3V4c0-1.7 1.3-3 3-3z",
    style: {
      fill: "#fff"
    }
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "dropzone_illustration_svg__SVGID_4_",
    d: "M4 1h105c1.7 0 3 1.3 3 3v78c0 1.7-1.3 3-3 3H4c-1.7 0-3-1.3-3-3V4c0-1.7 1.3-3 3-3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "dropzone_illustration_svg__SVGID_5_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dropzone_illustration_svg__SVGID_4_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#dropzone_illustration_svg__SVGID_5_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 1h105c1.7 0 3 1.3 3 3v78c0 1.7-1.3 3-3 3H4c-1.7 0-3-1.3-3-3V4c0-1.7 1.3-3 3-3z",
    style: {
      fill: "none",
      stroke: "#09c",
      strokeWidth: 2,
      strokeMiterlimit: 10,
      strokeDasharray: "5,5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "dropzone_illustration_svg__valid2",
    transform: "translate(16)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dropzone_illustration_svg__Shape_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -245.995,
    y1: 354.142,
    x2: -245.995,
    y2: 355.042,
    gradientTransform: "matrix(68.1868 0 0 -85.1786 16817.516 30267.75)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#faa94e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f47d4d"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "dropzone_illustration_svg__Shape",
    d: "M58.6 102.4H16.3c-1.6 0-3-1.4-3-3.1V28.7c0-1.6 1.4-3.1 3-3.1h55.3c1.6 0 3 1.4 3 3.1v60",
    style: {
      opacity: 0.25,
      fill: "url(#dropzone_illustration_svg__Shape_3_)",
      enableBackground: "new"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dropzone_illustration_svg__Shape_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -245.945,
    y1: 354.002,
    x2: -245.945,
    y2: 355.057,
    gradientTransform: "matrix(67.3846 0 0 -83.5714 16612.152 29687.57)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#faa94e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f47d4d"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "dropzone_illustration_svg__Shape_1_",
    d: "M53.8 96.6H11.9c-1.6 0-3-1.2-3-3V24.3c0-1.6 1.4-3 3-3h54.7c1.6 0 3 1.4 3 3v58.9",
    style: {
      fill: "#fff",
      stroke: "url(#dropzone_illustration_svg__Shape_4_)",
      strokeWidth: 3.2
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dropzone_illustration_svg__Shape_5_",
    gradientUnits: "userSpaceOnUse",
    x1: -243.008,
    y1: 339.83,
    x2: -243.008,
    y2: 341.15,
    gradientTransform: "matrix(36.9011 0 0 -14.6785 9006.517 5043.182)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#faa94e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f47d4d"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "dropzone_illustration_svg__Shape_2_",
    d: "M22.6 38.7h33.2M22.6 51.9h33.2",
    style: {
      fill: "none",
      stroke: "url(#dropzone_illustration_svg__Shape_5_)",
      strokeWidth: 3.2
    }
  })), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "dropzone_illustration_svg__SVGID_6_",
    d: "m84.7 111 5.4-5.4 5.3 5.3 5-5-5.3-5.3 5.4-5.4-21-6.4c-.5-.2-1.1.1-1.2.7-.1.2-.1.4 0 .6l6.4 20.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "dropzone_illustration_svg__SVGID_7_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dropzone_illustration_svg__SVGID_6_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#dropzone_illustration_svg__SVGID_7_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-45.001 88.23 98.699)",
    style: {
      fill: "#eef2f4"
    },
    d: "M72 80h32.4v37.4H72z"
  })), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "dropzone_illustration_svg__SVGID_8_",
    d: "m82 109.5 5.4-5.4 5.3 5.3 5-5-5.3-5.3 5.4-5.4-21-6.4c-.5-.2-1.1.1-1.2.7-.1.2-.1.4 0 .6l6.4 20.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "dropzone_illustration_svg__SVGID_9_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dropzone_illustration_svg__SVGID_8_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dropzone_illustration_svg__SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.362,
    y1: 98.281,
    x2: 98.996,
    y2: 98.281
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#faa94e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f47d4d"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m76 88.9 5.7 19.1c.2.5.7.8 1.2.7.2 0 .3-.1.4-.2l4.2-4.2 4.5 4.5c.4.4 1 .4 1.4 0l3.6-3.6c.4-.4.4-1 0-1.4l-4.5-4.5 4.2-4.2c.4-.4.4-1 0-1.4-.1-.1-.3-.2-.4-.2l-19.1-5.7c-.5-.2-1.1.1-1.2.7-.1 0-.1.2 0 .4z",
    style: {
      fill: "#fff",
      stroke: "url(#dropzone_illustration_svg__SVGID_10_)",
      strokeWidth: 3.2
    }
  }));
};
export { SvgDropzoneIllustration as ReactComponent };
export default "data:image/svg+xml;base64,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";